import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ViewEditCommonComponent } from '../view-edit-common/view-edit-common.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { ServicesService } from '../../services/services.service';
import { error } from 'jquery';
import { customersViewComponent } from '../customers-view/customers-view.component';
import { ViewDetailsComponent } from '../view-details/view-details.component';

@Component({
  selector: 'app-shared-table',
  templateUrl: './shared-table.component.html',
  styleUrls: ['./shared-table.component.css']
})
export class SharedTableComponent {
  allcolumns: any[] = []
  ref: DynamicDialogRef | undefined;
  @Input() columns: any[] = [];
  @Input() tableName: any;
  @Input() data: any[] = [];
  @Input() componentName: any;
  @Input() dropdownOptions: { [key: string]: string[] } = {};
  @Input() triggerDialog: any;
  sortedColumnIndex: number | null = null;
  sortOrder: 'ASC' | 'DESC' = 'ASC';
  selectedRows: any[] = [];  // Array to hold selected rows
  isAllSelected: boolean   = false;
  @Output() sortChange: EventEmitter<{ columnKey: string, sortOrder: 'ASC' | 'DESC' }> = new EventEmitter();
  @Output() selectedRowsChange: EventEmitter<any[]> = new EventEmitter();
  @Output() selectedStructureChange: EventEmitter<{ rows: any[], type: string }> = new EventEmitter();
  @Output() invoiceEditActionEmit: EventEmitter<any[]> = new EventEmitter();
  @Output() columnsToExport: EventEmitter<any[]> = new EventEmitter();
  // @Output() invoiceActionEmit: EventEmitter<any[]> = new EventEmitter();
  @Output() reloadEvent: EventEmitter<number> = new EventEmitter();
  @Output() invoiceBudgetActionEmit = new EventEmitter<{ item: any; user: any }>();
  @Output() invoiceActionEmit = new EventEmitter<{ rowItem: any, item: any; action: any }>();
  selectAll: boolean = false;
  showHideColumnDropdown = false;
  sidebarType: any;
  userDetails: any;
  colToExport: any;
  colomnData: any;
  RoleSuperAdmin: any;
  accounts = [];
  getWarehouseList: any;
  user_details: any;
  userType: any;
  orderData: any;
  constructor(public accessControlService: AccessControlService, private dialog: MatDialog, public dialogService: DialogService, private cdr: ChangeDetectorRef,
    private services: ServicesService
  ) {
    this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!)
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    this.user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userType = this.user_details?.userType;
  }

  tooltipOptions = {
    showDelay: 150,
    autoHide: false,
    outerHeight: '50px'
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.orderData = this.data;
      // console.log("order data: " + JSON.stringify(this.orderData))
    }
  }
  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('user_details')!)
    // this.userDetails?.userRole.filter((role: any) => {
    //   if (role?.roleName == 'ROLE_SUPERUSER') {
    //     this.RoleSuperAdmin = role?.roleName
    //   }
    // });
    this.sidebarType = localStorage.getItem('sidebarType')!;
    this.updateTableHeight();
    this.cdr.detectChanges();
      this.allcolumns = this.columns

    // this.getUserTableListByUserId()
    this.selectAll = this.allcolumns.every(col => col.showColumn);

  }

  updateTableHeight() {
    setTimeout(() => {
      const tableElement = document.querySelector(".p-datatable");

      if (!tableElement) return;

      if (this.sidebarType === 'top') {
        tableElement.classList.add("top");
      } else {
        tableElement.classList.remove("top");
      }
    }, 0); // Adjust delay if needed
  }

  sortApproval(data: any) {
    return data.sort((a: any, b: any) => a.sequence - b.sequence);
  }

  sortData(columnIndex: number, columnKey: string): void {
    this.sortOrder = this.sortedColumnIndex === columnIndex && this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    this.sortedColumnIndex = columnIndex;

    this.data.sort((a, b) => {
      const valueA = a[columnKey];
      const valueB = b[columnKey];

      console.log(`Sorting by column: ${columnKey} (index: ${columnIndex}), Order: ${this.sortOrder}`);

      // Sorting logic based on the order
      if (valueA < valueB) return this.sortOrder === 'ASC' ? -1 : 1;
      if (valueA > valueB) return this.sortOrder === 'ASC' ? 1 : -1;
      return 0;
    });
    // Emit the sort change event to the parent component
    this.sortChange.emit({ columnKey, sortOrder: this.sortOrder });

    console.log('Sorted Data:', this.data);
  }
  openCustomerDetailsDialog(column: any, row: any): void {
    if (column) {
      const columnKey = column.key;
      let filteredColumns = this.columns.filter(col => col.header !== 'Action');
      let rowData = { ...row };
      this.ref = this.dialogService.open(customersViewComponent, {
        data: {
          rowData: rowData,
          columns: filteredColumns,
          triggerDialog: columnKey,
          printData: true,
          componentName: column.componentName,
          viewHistory: column.viewHistory
        },
        styleClass: 'no-close-icon-dialog',
        header: `Customer Details`,
        width: '70vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true
      });

      this.ref.onClose.subscribe((result: any) => {
        // if (result) {
        console.log('Dialog closed with result:', result);
        this.reloadEvent.emit(result);
        // }
      });
    }
  }

  openDetailspopUp(column: any, row: any): void {
     const columnKey = column.key;
      let filteredColumns = this.columns.filter(col => col.header !== 'Action');
      let rowData = { ...row };
      this.ref = this.dialogService.open(ViewDetailsComponent, {
        header: `Details`,
        data: {
          rowData: rowData,
          columns: filteredColumns,
          triggerDialog: columnKey,
          printData: true,
          componentName: column.componentName,
          viewHistory: column.viewHistory
        },
        width: '65vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true
      });

      this.ref.onClose.subscribe((result: any) => {
        // if (result) {
        console.log('Dialog closed with result:', result);
        this.reloadEvent.emit(result);
        // }
      });
  }
  openRowDetailsDialog(column: any, row: any): void {
    // console.log(column)
    if (column) {
      const columnKey = column.key;
      let filteredColumns = this.columns.filter(col => col.header !== 'Action');
      let rowData = { ...row };

      //    // Check if "Current Approver" exists in columns
      //    this.columns.forEach(col => {
      //     if (col.key === 'approvalUser') {
      //         if (col.type === 'currentApprover') {
      //             // Assign the current approver separately
      //             rowData['currentApprover'] = this.getCurrentApprover(row.approvalUser || []);
      //         } else if (col.type === 'approvalUser') {
      //             // Keep the full approvalUser list
      //             rowData['approvalUser'] = row.approvalUser;
      //         }
      //     }
      // });


      this.ref = this.dialogService.open(ViewEditCommonComponent, {
        header: `Order No. ${rowData?.jobCode}`,
        data: {
          rowData: rowData,
          columns: filteredColumns,
          triggerDialog: columnKey,
          printData: true,
          componentName: column.componentName,
          viewHistory: column.viewHistory
        },
        width: '65vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true
      });

      this.ref.onClose.subscribe((result: any) => {
        // if (result) {
        console.log('Dialog closed with result:', result);
        this.reloadEvent.emit(result);
        // }
      });
    }

    else if (row) {
      const columnKey = this.columns.find(col => col.viewDialog === true)?.key; // Get column with viewDialog: true
      if (columnKey) {
        this.ref = this.dialogService.open(ViewEditCommonComponent, {
          header: `Order No. ${row?.jobCode}`,
          data: {
            rowData: row,
            // columns: this.columns.map(col => col.header),
            triggerDialog: columnKey,
            printData: true,
          },
          width: '65vw',
          contentStyle: { overflow: 'auto', position: "top" },
          draggable: true
        });

        this.ref.onClose.subscribe((result: any) => {
          // if (result) {
          console.log('Dialog closed with result:', result);
          this.reloadEvent.emit(result);
          // }
        });
      }
    }
  }

  getCurrentApprover(approvalUsers: any[]): string {
    const approver = approvalUsers.find(user => user.approvalStatus === 1);
    return approver ? approver.name : 'N/A';
  }


  toggleSelectAll() {
    if (this.isAllSelected) {
      this.data.forEach(row => row.selected = true);
      this.selectedRows = [...this.data];
      console.log(this.selectedRows)
    } else {
      this.data.forEach(row => row.selected = false);
      this.selectedRows = [];
    }
    this.selectedRowsChange.emit(this.selectedRows);
  }

configStructure(row: any, type: string) {
  if (row) {
    this.selectedRows = [];
    this.selectedRows.push(row);

    // this.selectedRowsChange.emit(this.selectedRows);
  }
  // if (row.selected) {
  //   this.selectedRows = this.data.filter(r => r.selected);
  // } else {
  //   this.selectedRows = this.selectedRows.filter(r => r !== row);
  // }
  // console.log(this.selectedRows)
  // console.log(row , type)
  this.isAllSelected = this.data.every(r => r.selected);
  this.selectedStructureChange.emit({
    rows: this.selectedRows,
    type: type
  });
}
  onRowSelect(row: any) {
    if (row) {
      this.selectedRows = []
      this.selectedRows.push(row);
      this.selectedRowsChange.emit(this.selectedRows); 
    }
    if (row.selected) {
      this.selectedRows = this.data.filter(r => r.selected);
    } else {
      this.selectedRows = this.selectedRows.filter(r => r !== row);
    }

    this.isAllSelected = this.data.every(r => r.selected);
    this.selectedRowsChange.emit(this.selectedRows);

  }
  invoiceEditAction(row: any) {
    this.selectedRows = this.data.filter(r => r.id == row.id);
    this.invoiceEditActionEmit.emit(this.selectedRows);
  }
  invoiceAction(rowItem: any, item: any, action: any) {
    console.log(item)
    if (item?.isActionOnLineItem) {
      if (action == 'approve' || action == 'reject' || action == 'comment') {
        const colom = { showColumn: true, key: "internalInvoiceNumber", header: "Invoice No", sortable: false, type: "text", viewDialog: true }
        this.openRowDetailsDialog(colom, rowItem)
      }
    } else {
      this.invoiceActionEmit.emit({ rowItem, item, action });
    }
  }
  invoiceBudgetAction(item: any, user: any) {
    console.log("item", item)
    const lineitem = { item, user };
    // this.invoiceBudgetActionEmit.emit(lineitem);
    this.invoiceBudgetActionEmit.emit({ item, user });
  }


  getStatusText(value: string): string {
    switch (value) {
      case 'PendingOnVendor': return 'Pending On Vendor';
      case 'AcceptedByVendor': return 'Accepted By Vendor';
      case 'RejectedByVendor': return 'Rejected By Vendor';
      case 'PendingOnCustomer': return 'Pending On Customer';
      case 'AcceptedByCustomer': return 'Accepted By Customer';
      case 'RejectedByCustomer': return 'Rejected By Customer';
      case 'AcceptedByUser': return 'Accepted By User';
      case 'RejectedByUser': return 'Rejected By User';
      default: return value;
    }
  }

toggleAllColumns() {
  this.allcolumns.forEach(col => col.showColumn = this.selectAll);
  this.toggleColumnVisibility(); // Sync with backend/localStorage
}
deselectAllColumns() {
  this.selectAll = false;
  this.allcolumns.forEach(col => col.showColumn = false);
  this.toggleColumnVisibility();
}

  toggleColumnVisibility() {
    console.log("--------------" + JSON.stringify(this.colomnData))
    const allData = JSON.parse(localStorage.getItem('columnToExport') || '{}');
    allData[this.componentName] = this.allcolumns
      .filter(col => col.showColumn)
      .map(col => col.key);

    localStorage.setItem('columnToExport', JSON.stringify(allData));

    this.data?.forEach((row: any) => {
      row.selected = false;
      this.isAllSelected = false;
    });

    const colom = JSON.stringify(this.allcolumns);
    const payload =
    {
      "userId": this.userDetails?.id,
      "tableName": this.tableName,
      "tableJson": colom
    }
    this.services.viewColom(payload).subscribe((res: any) => {
      console.log(res)
      this.getUserTableListByUserId()
    })
  }


  getUserTableListByUserId() {
    this.services.getUserTableListByUserId(this.userDetails?.id).subscribe((res: any) => {
      // console.log(res?.responseObject,this.tableName)
      this.colomnData = res.responseObject[this.tableName]
      if (this.colomnData) {
        this.columns = JSON.parse(this.colomnData)
        this.allcolumns = JSON.parse(this.colomnData)
      } else {
        this.columns = this.columns
        this.allcolumns = this.columns
      }
      // console.log(colomData)
      // console.log(this.columns)
    }, error => {
      console.log(error)
      this.columns = this.columns
      this.allcolumns = this.columns
    })
  }


  filteredApprovers(list: any[], row: any): any[] {
    // console.log(list)
    if (!list?.length) return [];

    const statusList = list.map((item) => item.approvalStatus);

    const countOf2 = statusList.filter(status => status === 2).length;
    const countOf5 = statusList.filter(status => status === 5).length;
    const countOf9 = statusList.filter(status => status === 9).length;
    const totalItems = statusList.length;

    // Condition: all must be 2 or exactly one 5
    if ((countOf2 + countOf5 === totalItems) && (countOf5 === 1)) {
      return list.slice(-3);  // last 3 items
    }

    // Partially Approved  Condition: all must be 2 or exactly one 9
    if ((countOf2 + countOf9 === totalItems) && (countOf9 === 1)) {
      return list.slice(-3);  // last 3 items
    }

    if (list.every(item => item.approvalStatus === 2)) {
      return list.slice(-3);
    }
    // const targetStatuses = [5, 6];
    // if(targetStatuses){
    //   return list.filter(user => targetStatuses.includes(user.approvalStatus))
    //   .slice(-3); // get last 3 of those
    // }

    const statusMapping: Record<string, number> = {
      COMMENTED: 4,
      REJECTED: 3,
      PENDING_BUDGET_UPDATE: 2,
      // PARTIALLY_APPROVED:9
    };

    // Find the current approver based on row.approvalStatus
    const approvalStatus = statusMapping[row?.approvalStatus] ?? 1;
    const currentIndex = list.findIndex(item => item.approvalStatus === approvalStatus && item.viewStatus === 1);

    if (currentIndex === -1) return [];

    const excludeAfterUser = row?.approvalStatus === "COMMENTED" || row?.approvalStatus === "REJECTED";

    return list
      .filter((_, index) =>
        index === currentIndex || index === currentIndex - 1 ||
        (!excludeAfterUser && index === currentIndex + 1)
      )
      .map((item, index) => ({
        ...item,
        position: index === currentIndex ? 'current' : 'before'
      }));
  }

  getDisplayValue(value: any): any {
    return (typeof value === 'number' && value === 0) ? '' : this.getStatusText(value);
  }

actionOnOrderRecord(row: any): boolean {
  if (this.userType !== 'VENDOR') return false;

  const vendorIds = (this.user_details?.vendorMapping || []).map((el: any) => el.vendorId || el.id);

  return (row?.jobLineItems || []).some(
    (item: any) => vendorIds.includes(item.vendorId) && item.status === 'Pending_V'
  );
}
isLongContent(value: any): boolean {
  return value?.toString()?.length > 55;
}
}
